<ion-content class="background">
  <div [ngClass]="{'ios-space-top': platform.is('ios')}"></div>
  <div class="sub-title-2">
    <ion-label>Información de la solicitud</ion-label>
  </div>

  <ion-grid class="content-resume">
    <ion-row>
      <ion-col>
        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary">Solicitud # : <span class="t-bold">{{itemKit.id}}</span> </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Material Solicitado:
              <span class="t-bold">{{itemKit.study_type}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Cantidad de pacientes:
              <span class="t-bold">{{itemKit.count_patient}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none" *ngIf="itemKit.comments">
          <ion-label color="tertiary">
            <ion-label color="tertiary">
              Comentarios:
              <span class="t-bold"> {{itemKit.comments}} </span>
            </ion-label>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div class="sub-title-2">
    <ion-label>Información de lugar de entrega</ion-label>
  </div>

  <ion-grid class="content-resume">
    <ion-row>
      <ion-col>
        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary">País: <span class="t-bold">{{itemKit.country_name}}</span> </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary">
              {{ "Provincia" | translate }}:
              <span class="t-bold">{{itemKit.state_name}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >{{"Localidad" | translate }}:
              <span class="t-bold">{{itemKit.city_name}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary">Dirección: <span class="t-bold">{{itemKit.address_name}}</span> </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none" *ngIf="itemKit.postal.length > 1">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary">Cod. Postal: <span class="t-bold">{{itemKit.postal}}</span> </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >institución:
              <span class="t-bold">{{itemKit.institution_name}}</span>
            </ion-label>
          </ion-label>
        </ion-item>
        <ion-item lines="none" *ngIf="itemKit.observation.length > 1">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Observaciones:
              <span class="t-bold">{{itemKit.observation}}</span>
            </ion-label>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="sub-title-2">
    <ion-label>Información de Contacto</ion-label>
  </div>

  <ion-grid class="content-resume">
    <ion-row>
      <ion-col>
        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Nombre del contacto:
              <span class="t-bold">{{itemKit.contact_info.name_conctact}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Código país:
              <span class="t-bold">{{itemKit.contact_info.cod_pais}}</span>
            </ion-label>
          </ion-label>
        </ion-item>

        <!-- <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Prefijo:
              <span class="t-bold">{{itemKit.contact_info.prefix}}</span>
            </ion-label>
          </ion-label>
        </ion-item> -->

        <ion-item lines="none">
          <ion-label color="tertiary" class="t-ce">
            <ion-label color="tertiary"
              >Teléfono:
              <span class="t-bold"> ({{itemKit.contact_info.prefix}}) - {{itemKit.contact_info.phone}}</span>
            </ion-label>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div class="sub-title-2">
    <ion-label>Horarios de Atención</ion-label>
  </div>

  <ion-grid class="content-resume">
    <!-- ✅ Mostrar tarjetas individuales para cada fecha con horario -->
    <div *ngIf="itemKit.horary && itemKit.horary.length > 0 && hasValidDates()">
      <ion-row class="pickup-date-target">
        <ng-container *ngFor="let horario of itemKit.horary">
          <ion-col *ngIf="isValidDate(horario.date)" size="12" class="pickup-date">
            <div>
              <ion-label>
                Fecha de entrega: <b>{{formatDate(horario.date)}}</b>
              </ion-label>
            </div>
            <div>
              <ion-label>
                Hora de inicio: <b>{{formatTime(horario.first_hour)}}</b>
              </ion-label>
            </div>
            <div>
              <ion-label>
                Hora de fin: <b>{{formatTime(horario.last_hour)}}</b>
              </ion-label>
            </div>
          </ion-col>
        </ng-container>
      </ion-row>
    </div>
    
    <!-- ✅ Fallback para solicitudes antiguas sin fechas específicas -->
    <div *ngIf="itemKit.horary && itemKit.horary.length > 0 && !itemKit.horary[0].date" class="pickup-date-target">
      <ion-col size="12" style="display: block;" class="pickup-date">
        <div>
          <ion-label>
            Fecha de entrega: <b>Lunes a Viernes 9:00 a 15:00 (Sin fecha específica registrada)</b>
          </ion-label>
        </div>
      </ion-col>
    </div>

    <!-- ✅ Mensaje cuando no hay horarios -->
    <div *ngIf="!itemKit.horary || itemKit.horary.length === 0" class="no-schedules">
      <ion-text color="medium">No hay horarios programados</ion-text>
    </div>
  </ion-grid>

  <div class="sub-title-2">
    <ion-label>Rastreo de la Solicitud</ion-label>
  </div>

  <ion-grid class="content-resume">
    <ion-row>
      <ion-col>
        <ng-container *ngFor="let item of itemKit.events">
          <div class="px-4 t-ce" *ngIf="item.date.length > 0">
            <div style="padding: 0px !important">
              <ion-item lines="none">
                <ion-label color="tertiary" class="t-ce">
                  <ion-label color="tertiary"
                    >Estado :
                    <span class="t-bold">{{item.event_name}}</span>
                  </ion-label>
                </ion-label>
              </ion-item>

              <ion-item lines="none" *ngIf="item.observation.length > 0">
                <ion-label color="tertiary" class="t-ce">
                  <ion-label color="tertiary"
                    >Observaciones:
                    <span class="t-bold">{{item.observation}} </span>
                  </ion-label>
                </ion-label>
              </ion-item>

              <ion-item lines="none">
                <ion-label color="tertiary" class="t-ce">
                  <ion-label color="tertiary">Fecha : <span class="t-bold">{{item.date}} </span></ion-label>
                </ion-label>
              </ion-item>
            </div>
          </div>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- Input Botones -->
  <ion-grid>
    <ion-row style="margin-top: 1rem !important">
      <ion-col class="ion-text-center btn-message" size="12">
        <app-btn-support [message]="messageSupport"></app-btn-support>
      </ion-col>

      <ion-col class="ion-text-center" size="12">
        <button (click)="closeModal()" id="btn-close-modal" class="btn-primary btn-close">Cerrar</button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
